export enum AgentHarnessRunStatus {
    Queued = 'queued',
    AwaitingFirstResponse = 'awaiting_first_response',
    Running = 'running',
    ActionRequired = 'action_required',
    Completed = 'completed',
    Failed = 'failed',
    Denied = 'denied',
    Stale = 'stale',
    Cancelled = 'cancelled',
}

export const AGENT_HARNESS_ACTIVE_RUN_STATUSES = [
    AgentHarnessRunStatus.Queued,
    AgentHarnessRunStatus.AwaitingFirstResponse,
    AgentHarnessRunStatus.Running,
    AgentHarnessRunStatus.ActionRequired,
] as const;

export const AGENT_HARNESS_TERMINAL_RUN_STATUSES = [
    AgentHarnessRunStatus.Completed,
    AgentHarnessRunStatus.Failed,
    AgentHarnessRunStatus.Denied,
    AgentHarnessRunStatus.Stale,
    AgentHarnessRunStatus.Cancelled,
] as const;
